import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { SIDEBAR_MINIMIZED } from '@/local-storage/LocalStorageKeys'

const state = {
  sidebar: {
    minimized: LocalStorageHelper.get(SIDEBAR_MINIMIZED) || false,
  },
  config: {
    googleMaps: {
      apiKey: 'AIzaSyCF88rJ-zeED--inAiwScQLZkuldVypjcE', // Vuestic -> 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ'
    },
    palette: {
      primary: '#29C4AA',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#414141',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
}

const mutations = {
  'TOGGLE_SIDEBAR': function (state, minimized) {
    state.sidebar.minimized = minimized
    LocalStorageHelper.set(SIDEBAR_MINIMIZED, minimized)
  },
  'TOGGLE_WITHOUT_ANIMATION': function (state, value) {
    state.sidebar.withoutAnimation = value
  },
  'SET_LOADING': function (state, isLoading) {
    state.isLoading = isLoading
  },
}

const actions = {
  toggleSidebar ({ commit }, minimized) {
    commit('TOGGLE_SIDEBAR', minimized)
  },
  isToggleWithoutAnimation ({ commit }, value) {
    commit('TOGGLE_WITHOUT_ANIMATION', value)
  },
}

export default {
  state,
  mutations,
  actions,
}
